import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitCreateAgencyProfile,
  submitUpdateAgencyProfile
} from '~/api/data/access-profiles/mutations';
import {
  loadAgencyProfile,
  loadAgencyProfileAssignments,
  loadAgencyProfileCapabilityCatalog,
  loadAgencyProfiles
} from '~/api/data/access-profiles/queries';
import { loadCustomPresets } from '~/api/data/presets/queries';
import { Action, Resource } from '~/api/graphql';
import { ProtectedRoute } from '~/components/permissions';
import { SettingsAgencyProfileDetailPage } from '~/pages/settings/agency-profile-detail';
import {
  SettingsAgencyProfileCreatePage,
  SettingsAgencyProfilesPage
} from '~/pages/settings/agency-profiles';

export const accessProfileRoutes: RouteObject[] = [
  {
    path: 'access-profiles',
    loader: merge({
      agencyProfiles: loadAgencyProfiles
    }),
    element: (
      <ProtectedRoute
        permissions={[{ resource: Resource.AgencyProfile, action: Action.List }]}
        redirectTo="/app/settings/profile"
      >
        <SettingsAgencyProfilesPage />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'new',
        action: byMethod({
          POST: submitCreateAgencyProfile
        }),
        element: <SettingsAgencyProfileCreatePage />
      }
    ]
  },
  {
    path: 'access-profiles/:id',
    loader: merge({
      agencyProfile: loadAgencyProfile,
      agencyProfileCapabilityCatalog: loadAgencyProfileCapabilityCatalog,
      customPresets: loadCustomPresets,
      agencyProfileAssignments: loadAgencyProfileAssignments
    }),
    action: byMethod({
      PUT: submitUpdateAgencyProfile
    }),
    element: (
      <ProtectedRoute
        permissions={[{ resource: Resource.AgencyProfile, action: Action.Read }]}
        redirectTo="/app/settings/profile"
      >
        <SettingsAgencyProfileDetailPage />
      </ProtectedRoute>
    )
  }
];
